@if (isOpen()) {
  <div class="fixed inset-0 z-[9000] bg-black/30 backdrop-blur-[3px]" (click)="close()" aria-hidden="true"></div>

  <div class="fixed inset-0 z-[9001] flex items-center justify-center pointer-events-none">
    <div class="w-[900px] max-w-[100vw] max-h-[88vh] overflow-y-auto bg-white rounded-2xl shadow-2xl border border-slate-200 pointer-events-auto" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between px-6 pt-5 pb-4 border-b border-slate-200">
        <h2 class="text-base font-semibold tracking-tight" style="color: var(--text-primary)">{{ 'profile.title' | translate }}</h2>
        <button type="button" (click)="close()" class="cursor-pointer flex items-center justify-center w-7 h-7 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">
          <cui-icon name="close" size="sm" color="currentColor" />
        </button>
      </div>

      <div class="px-6 pt-4">
        <p-tabs [tabs]="tabs" [activeIndex]="activeTab()" (tabChange)="selectTab($event)" />
      </div>

      <div class="px-6 py-6">
        @switch (activeTab()) {
          @case (0) {
            <div class="flex items-center gap-4 mb-6">
              <img [src]="accountModel().avatarUrl" alt="" class="w-16 h-16 rounded-full object-cover" />
              <div>
                <div class="text-sm font-semibold" style="color: var(--text-primary)">{{ accountModel().fullName }}</div>
                <div class="text-xs" style="color: var(--text-muted)">{{ accountModel().email }}</div>
                <button type="button" class="text-xs font-medium mt-1 cursor-pointer" style="color: var(--auth-primary)">{{ 'profile.changePhoto' | translate }}</button>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-x-6 gap-y-4">
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.fullName' | translate }} <span class="required">*</span></label>
                <p-input [formField]="accountForm.fullName" [fullWidth]="true" placeholder="{{ 'profile.fullName' | translate }}" />
                @if (accountForm.fullName().invalid() && accountForm.fullName().touched()) {
                  <ul class="mt-1 required">
                    @for (error of accountForm.fullName().errors(); track error) {
                      <li>{{ error.message | translate }}</li>
                    }
                  </ul>
                }
              </div>
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.nameKhmer' | translate }}</label>
                <p-input [formField]="accountForm.nameKhmer" [fullWidth]="true" placeholder="{{ 'profile.nameKhmer' | translate }}" />
              </div>

              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.username' | translate }} <span class="required">*</span></label>
                <p-input [formField]="accountForm.username" [fullWidth]="true" placeholder="{{ 'profile.username' | translate }}" />
                @if (accountForm.username().invalid() && accountForm.username().touched()) {
                  <ul class="mt-1 required">
                    @for (error of accountForm.username().errors(); track error) {
                      <li>{{ error.message | translate }}</li>
                    }
                  </ul>
                }
              </div>
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.dateOfBirth' | translate }}</label>
                <p-datepicker [formField]="accountForm.dateOfBirth" [dateFormat]="dateFormat()" [fullWidth]="true" placeholder="{{ 'profile.dateOfBirth' | translate }}" />
              </div>

              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.email' | translate }} <span class="required">*</span></label>
                <p-input [formField]="accountForm.email" [fullWidth]="true" placeholder="{{ 'profile.email' | translate }}" />
                @if (accountForm.email().invalid() && accountForm.email().touched()) {
                  <ul class="mt-1 required">
                    @for (error of accountForm.email().errors(); track error) {
                      <li>{{ error.message | translate }}</li>
                    }
                  </ul>
                }
              </div>
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.gender' | translate }}</label>
                <p-select [formField]="accountForm.gender" [options]="genderOptions" [fullWidth]="true" placeholder="{{ 'profile.gender' | translate }}" />
              </div>
            </div>

            <div class="flex justify-end mt-6">
              <p-button [loading]="isSavingAccount()" [disabled]="accountForm().invalid()" (onClick)="saveAccount()">{{ 'button.save' | translate }}</p-button>
            </div>
          }
          @case (1) {
            <div class="flex items-center gap-4 mb-6">
              <img [src]="accountModel().avatarUrl" alt="" class="w-12 h-12 rounded-full object-cover" />
              <div class="text-sm font-semibold" style="color: var(--text-primary)">{{ accountModel().fullName }}</div>
            </div>

            <div class="mb-4">
              <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.currentPassword' | translate }} <span class="required">*</span></label>
              <p-password [formField]="passwordForm.currentPassword" [toggleMask]="true" [fullWidth]="true" [feedback]="false" placeholder="{{ 'profile.currentPassword' | translate }}" />
              @if (passwordForm.currentPassword().invalid() && passwordForm.currentPassword().touched()) {
                <ul class="mt-1 required">
                  @for (error of passwordForm.currentPassword().errors(); track error) {
                    <li>{{ error.message | translate }}</li>
                  }
                </ul>
              }
            </div>

            <div class="grid grid-cols-2 gap-x-6 gap-y-4">
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.newPassword' | translate }} <span class="required">*</span></label>
                <p-password [formField]="passwordForm.newPassword" [toggleMask]="true" [fullWidth]="true" [feedback]="false" placeholder="{{ 'profile.newPassword' | translate }}" />
                @if (passwordForm.newPassword().invalid() && passwordForm.newPassword().touched()) {
                  <ul class="mt-1 required">
                    @for (error of passwordForm.newPassword().errors(); track error) {
                      <li>{{ error.message | translate }}</li>
                    }
                  </ul>
                }
              </div>
              <div>
                <label class="block text-xs font-medium mb-2" style="color: var(--text-muted)">{{ 'profile.confirmPassword' | translate }} <span class="required">*</span></label>
                <p-password [formField]="passwordForm.confirmPassword" [toggleMask]="true" [fullWidth]="true" [feedback]="false" placeholder="{{ 'profile.confirmPassword' | translate }}" />
                @if (passwordForm.confirmPassword().invalid() && passwordForm.confirmPassword().touched()) {
                  <ul class="mt-1 required">
                    @for (error of passwordForm.confirmPassword().errors(); track error) {
                      <li>{{ error.message | translate }}</li>
                    }
                  </ul>
                }
              </div>
            </div>

            <div class="flex justify-end mt-6">
              <p-button [loading]="isSavingPassword()" [disabled]="passwordForm().invalid()" (onClick)="savePassword()">{{ 'button.save' | translate }}</p-button>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
